"use strict";
function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
    for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
}
function _createClass(e, t, n) {
    return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}
if ("undefined" == typeof FrontendUtils) {
    var _FrontendUtils = (function () {
        function e() {
            _classCallCheck(this, e);
        }
        return (
            _createClass(e, [
                {
                    key: "getCookie",
                    value: function (e) {
                        var t = document.cookie.match(new RegExp("".concat(e, "=([^;]*)?(;|$)"), "im"));
                        return (t && t[1] && decodeURIComponent(t[1])) || null;
                    },
                },
                {
                    key: "setCookie",
                    value: function (e, t, n) {
                        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                            r = i.encode,
                            o = void 0 === r || r,
                            s = i.hostname,
                            a = void 0 === s ? window.location.hostname || "" : s,
                            c = i.path,
                            l = void 0 === c || c,
                            d = i.secure,
                            u = void 0 === d || d,
                            p = a.includes("ring.com") ? ".ring.com" : a,
                            f = o ? encodeURIComponent(t) : t;
                        document.cookie = ""
                            .concat(e, "=")
                            .concat(f, "; ")
                            .concat(n ? ";expires=".concat(n.toUTCString()) : "", " ")
                            .concat(p ? ";domain=".concat(p, ";") : "", " ")
                            .concat(l ? ";path=/;" : "", " ")
                            .concat(u ? ";secure" : "");
                    },
                },
                {
                    key: "getQueryParam",
                    value: function (e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.location.search;
                        return new URLSearchParams(t).get(e);
                    },
                },
                {
                    key: "isURL",
                    value: function (e) {
                        try {
                            return Boolean(new URL(e));
                        } catch (e) {
                            return !1;
                        }
                    },
                },
                {
                    key: "getDevice",
                    value: function () {
                        return window.innerWidth <= 600 ? "mobile" : window.innerWidth <= 768 ? "tablet" : "desktop";
                    },
                },
                {
                    key: "searchTermInType",
                    value: function (e, t) {
                        var n = t.find(function (t) {
                            return t.terms.includes(e.toLowerCase());
                        });
                        return n ? n.value : void 0;
                    },
                },
                {
                    key: "fixTypoInSearch",
                    value: function (e) {
                        return this.searchTermInType(e, window.searchConfig.typos);
                    },
                },
                {
                    key: "getRedirectForKey",
                    value: function (e) {
                        return this.searchTermInType(e, window.searchConfig.redirections);
                    },
                },
            ]),
            e
        );
    })();
    (window.frontendUtils = new _FrontendUtils()), "undefined" != typeof module && module.exports && (module.exports = { FrontendUtils: _FrontendUtils, frontendUtils: window.frontendUtils });
}
var ProductWrapperComponent = (function () {
    function e() {
        _classCallCheck(this, e), (this.wrappers = []), (this.isDesktop = { current: void 0, previous: void 0 });
    }
    return (
        _createClass(e, [
            {
                key: "init",
                value: function () {
                    this.setWrappers(), this.setDesktop(), this.setSlideConfig(), this.displayNavigations(), this.bindEvents();
                },
            },
            {
                key: "onResize",
                value: function () {
                    this.setDesktop(), this.setSlideConfig(), this.displayNavigations();
                },
            },
            {
                key: "bindEvents",
                value: function () {
                    this.setResizeListeners(), this.setDropdownListeners(), this.setNavigationListeners();
                },
            },
            {
                key: "debounce",
                value: function (e, t) {
                    var n;
                    return function () {
                        clearTimeout(n),
                            (n = setTimeout(function () {
                                (n = null), e();
                            }, t));
                    };
                },
            },
            {
                key: "setDesktop",
                value: function () {
                    var e = this.isDesktop.current,
                        t = window.innerWidth > 1023;
                    (this.isDesktop = { current: t, previous: e }),
                        e !== t &&
                            this.wrappers.forEach(function (e) {
                                (e.slideConfig.currentSlide = 1), (e.list.style.marginRight = 0);
                            });
                },
            },
            {
                key: "setWrappers",
                value: function () {
                    this.wrappers = Array.from(document.querySelectorAll(".product-strip")).map(function (e) {
                        return { container: e, list: e.querySelector(".product-strip__list"), navs: e.querySelectorAll(".product-strip__nav"), products: e.querySelectorAll(".plp-product"), slideConfig: {} };
                    });
                },
            },
            {
                key: "setDropdownListeners",
                value: function () {
                    var e = this;
                    document.querySelectorAll(".plp-product__dropdown").length &&
                        (this.wrappers.forEach(function (t) {
                            return t.products.forEach(function (t) {
                                var n = t.querySelector(".plp-product__dropdown");
                                t.addEventListener("click", function (t) {
                                    t.stopPropagation();
                                    var i = t.target.classList.contains("plp-product__dropdown-item") || t.target.parentElement.classList.contains("plp-product__dropdown-item");
                                    n && !i && t.preventDefault(), e.closeDropdowns(n), n && n.classList.toggle("plp-product__dropdown--open");
                                });
                            });
                        }),
                        window.addEventListener("click", this.closeDropdowns));
                },
            },
            {
                key: "setNavigationListeners",
                value: function () {
                    var e = this;
                    this.wrappers.forEach(function (t) {
                        return t.navs.forEach(function (n) {
                            n.addEventListener("click", e.handleClickNav.bind(e, t, n));
                        });
                    });
                },
            },
            {
                key: "setResizeListeners",
                value: function () {
                    window.addEventListener("resize", this.debounce(this.onResize.bind(this), 250));
                },
            },
            {
                key: "setSlideConfig",
                value: function () {
                    var e = this;
                    this.wrappers.forEach(function (t) {
                        var n = t.container,
                            i = t.products,
                            r = t.slideConfig.currentSlide || 1,
                            o = i.length,
                            s = e.calculateContainerWidth(n),
                            a = e.getItemsPerSlide(i, s),
                            c = Math.ceil(o / a),
                            l = e.isDesktop.current ? c : o - a + 1;
                        t.slideConfig = { currentSlide: r, itemsPerSlide: a, totalSlides: l };
                    });
                },
            },
            {
                key: "displayNavigations",
                value: function () {
                    this.wrappers.forEach(function (e) {
                        var t = e.container,
                            n = e.list,
                            i = e.products,
                            r = e.slideConfig,
                            o = r.currentSlide,
                            s = r.totalSlides,
                            a = t.querySelector(".product-strip__next"),
                            c = t.querySelector(".product-strip__prev");
                        a.classList.toggle("product-strip__nav--active", 1 !== o),
                            c.classList.toggle("product-strip__nav--active", o !== s),
                            i.length <= r.itemsPerSlide
                                ? (a.classList.remove("product-strip__nav--active"), c.classList.remove("product-strip__nav--active"), n.classList.add("product-strip__list--centered"), (n.style.marginRight = 0))
                                : n.classList.remove("product-strip__list--centered");
                    });
                },
            },
            {
                key: "closeDropdowns",
                value: function (e) {
                    var t = document.querySelectorAll(".plp-product__dropdown--open");
                    t.length &&
                        t.forEach(function (t) {
                            t !== e && t.classList.remove("plp-product__dropdown--open");
                        });
                },
            },
            {
                key: "handleClickNav",
                value: function (e, t) {
                    var n = e.list,
                        i = e.products,
                        r = e.slideConfig,
                        o = t.classList.contains("product-strip__prev") ? "right" : "left",
                        s = r.currentSlide,
                        a = r.itemsPerSlide,
                        c = r.totalSlides,
                        l = s - 1,
                        d = s - 2,
                        u = i[l] ? i[l].offsetWidth : 0,
                        p = i[d] ? i[d].offsetWidth : 0,
                        f = "right" === o ? s : s - 1,
                        v = this.calculateInnerContentWidth(i, f, a) - t.offsetWidth,
                        h = this.isDesktop.current,
                        m = parseFloat(n.style.marginRight.replace(/[^\d.]/g, ""));
                    if ("right" === o && s < c) {
                        var y = h ? v : u;
                        (n.style.marginRight = "".concat(-1 * (m + y), "px")), r.currentSlide++;
                    } else if ("left" === o && 1 !== s) {
                        var g = h ? v : p;
                        (n.style.marginRight = "".concat(-m + g, "px")), r.currentSlide--;
                    }
                    this.displayNavigations();
                },
            },
            {
                key: "calculateContainerWidth",
                value: function (e) {
                    var t = window.getComputedStyle(e),
                        n = t.paddingLeft,
                        i = t.paddingRight;
                    return e.offsetWidth - parseFloat(n || 0) - parseFloat(i || 0);
                },
            },
            {
                key: "calculateInnerContentWidth",
                value: function (e, t, n) {
                    var i = (t - 1) * n,
                        r = t * n;
                    return Array.from(e)
                        .slice(i, r)
                        .reduce(function (e, t) {
                            return e + t.offsetWidth;
                        }, 0);
                },
            },
            {
                key: "getItemsPerSlide",
                value: function (e, t) {
                    return Array.from(e).reduce(
                        function (e, n) {
                            if (((e.itemsWidth += n.offsetWidth), e.itemsWidth <= t)) return e.itemsPerSlide++, e;
                            var i = parseFloat(window.getComputedStyle(n).paddingRight || 0) - 10;
                            return e.itemsWidth - i <= t && e.itemsPerSlide++, e;
                        },
                        { itemsPerSlide: 0, itemsWidth: 0 }
                    ).itemsPerSlide;
                },
            },
        ]),
        e
    );
})();
!(function () {
    var e = new ProductWrapperComponent();
    "loading" !== document.readyState
        ? e.init()
        : document.addEventListener("DOMContentLoaded", function () {
              return e.init();
          });
})(),
    "undefined" != typeof module && module.exports && (module.exports = ProductWrapperComponent);
